import * as React from 'react';

import {Body} from '../typography/body';

import styles from './success-message.module.css';

type Props = {
    as: string;
    children: React.ReactNode;
};

SuccessMessage.defaultProps = {
    as: 'div',
};

export function SuccessMessage({children, as: Tag}: Props) {
    return (
        // @ts-expect-error
        <Tag className={styles.success}>
            <Body>{children}</Body>
        </Tag>
    );
}
